/**
 * 枚舉
 * 跳轉
 * @author J
 * @since 2024-04-30 07:34:25
 */

export const IntentEnum = Object.freeze({

    /**
     * 首頁
     */
    HOME: 0,

    /**
     * 重新載入
     */
    RELOAD: 1,

    /**
     * 前往
     */
    PUSH: 2,

    /**
     * 取代
     */
    REPLACE: 3,

    /**
     * 前往附掛頁面
     */
    ATTACH: 4,

    /**
     * 登入
     */
    LOGIN: 5,

    /**
     * 登出
     */
    LOGOUT: 6,

})